var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title: "赠送会员",
        visible: _vm.dialogVisibleMember,
        width: "540px",
        "before-close": _vm.handleResetForm,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleMember = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formValidate",
          staticClass: "formValidate",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.rules,
            "label-width": "80px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "会员卡：", required: "", prop: "cardId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择系统会员卡",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.formValidate.cardId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "cardId", $$v)
                    },
                    expression: "formValidate.cardId",
                  },
                },
                _vm._l(_vm.tableDataMember, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
              _c("div", { staticClass: "from-tips" }, [
                _vm._v("平台赠送的会员卡，不进行会员卡设置的余额赠送"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleResetForm } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loadingBtn },
              on: { click: _vm.handleSure },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }